export const scrollToHeading = e => {
	e.preventDefault();

	const siblingsFn = elem => {
		const siblings = [];
		let sibling = elem;
		while (sibling.previousSibling) {
			sibling = sibling.previousSibling;
			if (sibling.nodeType === 1) {
				siblings.push(sibling);
			}
		}

		sibling = elem;
		while (sibling.nextSibling) {
			sibling = sibling.nextSibling;
			if (sibling.nodeType === 1) {
				siblings.push(sibling);
			}
		}
		return siblings;
	};

	const link = e.target;
	const activeClass = "guide-post-container__nav-item-link--active";
	link.classList.add(activeClass);
	siblingsFn(link.parentNode).forEach(sib => {
		if (!sib.getElementsByTagName("a").length) {
			return;
		}
		sib.getElementsByTagName("a")[0].classList.remove(activeClass);
	});

	const id = e.target.hash.replace("#", "");
	const element = document.getElementById(id);
	global.window.scrollTo({
		behavior: element ? "smooth" : "auto",
		top: element ? element.offsetTop : 0,
	});
};
